import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import { transactionProxy } from '../../../../../../shared/proxies/transactionProxy'
import { GlobalTransactionStatus } from '../../../../../../shared/types/GlobalTransactionStatus'
import ExclamationCircleIcon from '../../../../../../shared/components/ui/icons/ExclamationCircleIcon'

export function TransactionErrorContainer (): ReactElement {
  const { transaction } = useSnapshot(transactionProxy)

  if (!transaction) {
    return (<></>)
  }

  const isErrored = transaction.status === GlobalTransactionStatus.Error

  if (!isErrored) {
    return (<></>)
  }

  return (
    <div className="bg-white shadow rounded py-4 mb-8 ml-4 px-6 text-red-400 ">
      <div className="flex flex-row">
        <span className="text-3xl pr-4">
          <ExclamationCircleIcon color="#F87171" />
        </span>
        <label className="font-semibold text-xl">
          {transaction.errorName}
        </label>
      </div>
      <p className="pl-12 mt-2 pb-8">
        <div>
          <span className="font-semibold">Details:</span>&nbsp;
          <div className="pb-1">
            {transaction.errorMessage}
          </div>
        </div>

      </p>
    </div>
  )
}
